import * as React from 'react';
import { TSInput } from '../../common/TSInput';
import { Row } from 'antd';
import { ExpenseNode, ExpenseError } from './constants';

export const ExpenseForm: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <Row>
      <TSInput
        error={props.error.head}
        value={props.value.head}
        onChange={props.onChange}
        name="head"
        type="text"
        addonBefore="Head"
      />
    </Row>
  );
};

interface Props {
  value: ExpenseNode;
  error: ExpenseError;
  onChange: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: any } },
  ) => void;
}
